import script from "./tb_content.vue?vue&type=script&lang=ts&setup=true"
export * from "./tb_content.vue?vue&type=script&lang=ts&setup=true"

import "./tb_content.vue?vue&type=style&index=0&id=11897362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11897362"]])

export default __exports__